export function getLocalStorageToken() {
  return localStorage.getItem('token');
}
